export default __webpack_public_path__ + "static/media/bulma.12ecb794.svg";